import React from "react";
const LogoutIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33398 1.33301H10.6673V2.66634H2.66732V17.333H10.6673V18.6663H1.33398V1.33301ZM14.4727 5.52767L18.926 9.98101L14.49 14.785L13.5113 13.881L16.478 10.6663H5.33398V9.33301H16.3913L13.5287 6.47167L14.4727 5.52767Z"
        fill="#4F93FE"
      />
    </svg>
  );
};

export default LogoutIcon;
